/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import TOC from '@ember/component/template-only';
import type { IJsonApiQuery } from 'volta/utils/api/jsonapi-types';

export interface ISkusWarehouseFilterDefinitionArgs {
  skuId?: string;
  horizontalPosition?: 'left' | 'right' | 'auto';
  beforeQuery?: (query: IJsonApiQuery) => IJsonApiQuery;
}

const FiltersSkusWarehouseFilterComponent = TOC<ISkusWarehouseFilterDefinitionArgs>();

export default FiltersSkusWarehouseFilterComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Filters::SkusWarehouseFilter': typeof FiltersSkusWarehouseFilterComponent;
    'filters/skus-warehouse-filter': typeof FiltersSkusWarehouseFilterComponent;
  }
}
